/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @description 文章
 */
import documentArticle from "./documentArticle";

export class ArticleApi {
  constructor(
    public documentArticle: (
      id: string,

      success?: ({
        data,
        ext,
        state,
        errors,
      }: {
        data: cms.DocumentsArticleDto;
        ext: ObjectMap;
        state: "SUCCESS" | "FAIL" | "EXCEPTION";
        errors?: Array<string>;
      }) => any,
      fail?: (error: string) => any
    ) => void
  ) {}
}

export default {
  documentArticle,
} as ArticleApi;
